import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { CURRENCY_CODE } from "../config";
import { STATE } from "../classes/Enum";
import { buy, paymentIntent as getPaymentIntent } from "../api/purchase"; // Ensure this API correctly records transactions in the backend

const StripePaymentComponent = ({ totalPrice, setIsProcessing, setError, cart, customerInfo, shippingPaid, couponCode, setState, user }) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsProcessing(true);
        setError(null);
    
        if (!stripe || !elements) {
            console.error("Stripe has not loaded.");
            setError("Stripe has not loaded.");
            setIsProcessing(false);
            return;
        }
    
        try {
            // ✅ 1. Create a PaymentIntent and retrieve clientSecret from backend
            const { clientSecret } = await getPaymentIntent(Math.round(totalPrice * 100), cart);  // Ensure `paymentIntent` function returns an object with clientSecret
            if (!clientSecret) {
                throw new Error("Failed to create PaymentIntent.");
            }

            // ✅ 2. Confirm payment with Stripe (Handles authentication if needed)
            elements.submit();
            const { error, paymentIntent } = await stripe.confirmPayment({
                elements,
                clientSecret, // Use the retrieved clientSecret
                confirmParams: {
                    return_url: window.location.href, // Provide a return URL, but it won’t be used
                },
                redirect: "if_required", // Prevents unwanted redirects
            });

            console.log("Confirmed payment!");

    
            if (error) {
                console.error("Stripe Payment Error:", error.message);
                setError(error.message);
                setIsProcessing(false);
                return;
            }
    
            console.log("PaymentIntent status:", paymentIntent.status);
    
            // ✅ 3. Call backend to record the successful payment
            const response = await buy(
                totalPrice,
                cart,
                "Card",  // Send paymentIntent.id instead of paymentMethod.id
                customerInfo,
                shippingPaid,
                couponCode,
                user
            );
    
            if (response.status === "succeeded") {
                console.log("Payment successful, updating UI...");
                setState(STATE.SUCCESS);
            } else {
                setError("Payment was processed but not recorded successfully.");
            }
        } catch (err) {
            console.error("Payment processing error:", err);
            setError("There was an issue processing the payment.");
        }
    
        setIsProcessing(false);
    };
    
    
    return (
        <form id="payment-element-form" onSubmit={handleSubmit}>
            <PaymentElement options={{
                layout: {
                    radios: true,
                    spacedAccordionItems: true,
                    type: "accordion", 
                },
                appearance: {
                    theme: "night",
                    variables: {
                        colorPrimary: "#007BFF",
                        fontSizeBase: "16px",
                        borderRadius: "8px",
                    },
                }
            }} />
            <button type="submit" id="pay-button">
                {'Pay $' + totalPrice + " " + CURRENCY_CODE.toUpperCase()}
            </button>
        </form>
    );
};

export default StripePaymentComponent;
